import type { ReactElement } from "react";
import { Check } from "lucide-react";

interface Feature {
  title: string;
  body: string;
}

const FEATURES: Feature[] = [
  {
    title: "Update by message",
    body: "Text or email Chill the way you would message a person.",
  },
  {
    title: "Pages and content",
    body: "Refresh your words, publish what is new, and keep key details current.",
  },
  {
    title: "Products and services",
    body: "Keep offerings, menus, pricing, and availability easy to understand.",
  },
  {
    title: "Media and forms",
    body: "Update photos and embeds, or give visitors a simple way to respond.",
  },
  {
    title: "Contact and domain",
    body: "Keep contact details current and connect your own domain with SSL included.",
  },
];

export function Features(): ReactElement {
  return (
    <section className="relative py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-24">
        <div className="lg:sticky lg:top-32 lg:self-start">
          <div className="marketing-kicker text-[#45635e]">What stays handled</div>
          <h2 className="marketing-display mt-5 max-w-xl text-5xl leading-[1.02] text-[#12211d] sm:text-6xl">
            Everything you need.{" "}
            <span className="block text-[#71817d]">Nothing to manage.</span>
          </h2>
          <p className="mt-7 max-w-lg text-lg leading-8 text-[#63716d]">
            The useful parts of a website remain close by. The machinery stays
            out of sight.
          </p>

          <div className="mt-10 inline-flex items-center gap-3 rounded-full border border-[#d5e9f7] bg-white px-4 py-2.5 text-xs text-[#536762]">
            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#eaf5fd] text-[#636793]">
              <Check className="h-3 w-3" aria-hidden="true" />
            </span>
            Hosting, domain, and updates included
          </div>
        </div>

        <div className="border-t border-[#d7e3df]">
          {FEATURES.map(({ title, body }, index) => (
            <div
              key={title}
              className="grid gap-3 border-b border-[#d7e3df] py-7 sm:grid-cols-[3rem_0.8fr_1.2fr] sm:items-baseline sm:gap-5 sm:py-9"
            >
              <span
                aria-hidden="true"
                className="font-mono text-[10px] text-[#65736f]"
              >
                0{index + 1}
              </span>
              <h3 className="text-base font-semibold tracking-[-0.02em] text-[#1b2b27]">
                {title}
              </h3>
              <p className="max-w-md text-sm leading-6 text-[#697773]">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
